enum GenerateInvoice {
  GENERATE_INVOICE = 'billing-periods/generate-invoice'
}

export default GenerateInvoice;
